export default __webpack_public_path__ + "static/media/img_mv_program_illustration.60230c3e.png";